"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var JackpotWinHistoryList = /** @class */ (function (_super) {
    __extends(JackpotWinHistoryList, _super);
    function JackpotWinHistoryList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Дата выигрыша',
                dataIndex: _this.props.data.dk_date_win,
                key: _this.props.data.dk_date_win,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_win.format(_this.state.dtFormat)));
                },
                width: 150,
            }, {
                title: 'Джек.',
                dataIndex: _this.props.data.dk_bonus_jackpot_title,
                key: _this.props.data.dk_bonus_jackpot_title,
                width: 120,
            }, {
                title: 'Игрок',
                dataIndex: _this.props.data.dk_usr_player_login,
                key: _this.props.data.dk_usr_player_login,
                width: 120,
            }, {
                title: 'Сумма Игрок/Джек.',
                dataIndex: _this.props.data.dk_win_amount_jp_currency,
                key: _this.props.data.dk_win_amount_jp_currency,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.win_amount_player_currency.toFixed(2),
                        record.player_currency_title,
                        "/",
                        record.win_amount_jp_currency.toFixed(2),
                        record.jackpot_currency_title));
                },
                width: 200,
            } /*, {
                title: 'Валюта игрока/джекпота',
                dataIndex: this.props.data.dk_player_currency_title,
                key: this.props.data.dk_player_currency_title,
                width: 200,
                render: (text, record, idx) => {
                    return (
                        <div>{record.player_currency_title}/{record.jackpot_currency_title}</div>
                    )
                },
            }, {
                title: 'Валюта джекпота',
                dataIndex: this.props.data.dk_jackpot_currency_title,
                key: this.props.data.dk_jackpot_currency_title,
                width: 150,
            }*/,
            {
                title: 'Курс обмена',
                dataIndex: _this.props.data.dk_exchange_rate,
                key: _this.props.data.dk_exchange_rate,
                width: 120,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.exchange_rate.toFixed(4)));
                }
            }, {
                title: 'Бал. игрок до/после',
                dataIndex: _this.props.data.dk_player_balance_before,
                key: _this.props.data.dk_player_balance_before,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.player_balance_before.toFixed(2),
                        "/",
                        record.player_balance_after.toFixed(2),
                        " ",
                        record.player_currency_title));
                }
            }, {
                title: 'Бал. джек. до/после',
                dataIndex: _this.props.data.dk_jackpot_balance_money_before,
                key: _this.props.data.dk_jackpot_balance_money_before,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.jackpot_balance_money_before.toFixed(2),
                        "/",
                        record.jackpot_balance_money_after.toFixed(2),
                        " ",
                        record.jackpot_currency_title));
                }
            }, {
                title: 'Вид джек. до/после',
                dataIndex: _this.props.data.dk_jackpot_balance_view_before,
                key: _this.props.data.dk_jackpot_balance_view_before,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.jackpot_balance_view_before.toFixed(2),
                        "/",
                        record.jackpot_balance_view_after.toFixed(2),
                        " ",
                        record.jackpot_currency_title));
                }
            } /*, {
                title: 'Баланс после',
                dataIndex: this.props.data.dk_player_balance_after,
                key: this.props.data.dk_player_balance_after,
                width: 150
            }*/,
            {
                title: 'Активировано',
                dataIndex: _this.props.data.dk_trg_by_usr_admin_login,
                key: _this.props.data.dk_trg_by_usr_admin_login,
                width: 120,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 120
            }
        ];
        return _this;
    }
    JackpotWinHistoryList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
            _this.props.state.setExtBreadCrumbPath(["\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430 - [" + _this.props.record.title + "]"]);
        });
    };
    JackpotWinHistoryList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    JackpotWinHistoryList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            jackpotId: this.props.record.key,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    JackpotWinHistoryList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0430 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.bonus_jackpot_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    JackpotWinHistoryList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
    };
    JackpotWinHistoryList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    JackpotWinHistoryList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад", create: "Создать" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.getTablePageSize(),
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u0430\u0442\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0430 :"),
                            " [",
                            record.date_win.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0438\u0433\u0440\u043E\u043A\u0430 \u0434\u043E:"),
                            " [",
                            record.player_balance_before.toFixed(2),
                            " ",
                            record.player_currency_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0438\u0433\u0440\u043E\u043A\u0430 \u043F\u043E\u0441\u043B\u0435:"),
                            " [",
                            record.player_balance_after.toFixed(2),
                            " ",
                            record.player_currency_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430(\u0434\u0435\u043D\u044C\u0433\u0438) \u0434\u043E:"),
                            " [",
                            record.jackpot_balance_money_before.toFixed(2),
                            " ",
                            record.jackpot_currency_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430(\u0434\u0435\u043D\u044C\u0433\u0438) \u043F\u043E\u0441\u043B\u0435:"),
                            " [",
                            record.jackpot_balance_money_after.toFixed(2),
                            " ",
                            record.jackpot_currency_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430(\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435) \u0434\u043E:"),
                            " [",
                            record.jackpot_balance_view_before.toFixed(2),
                            " ",
                            record.jackpot_currency_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430(\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435) \u043F\u043E\u0441\u043B\u0435:"),
                            " [",
                            record.jackpot_balance_view_after.toFixed(2),
                            " ",
                            record.jackpot_currency_title,
                            "]")));
                }, scroll: { x: true } })));
    };
    return JackpotWinHistoryList;
}(React.Component));
exports.default = JackpotWinHistoryList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/win_history/JackpotWinHistoryList.tsx
// module id = 2347
// module chunks = 0